import type { Flag, IFlag } from './flag';

export interface IFeatureFlags {
	flags: IFlag[];
}

export class FeatureFlags implements IFeatureFlags {
	public flags: Flag[];
	public constructor({ flags }: IFeatureFlags) {
		this.flags = flags;
	}
}
